let xwind_ldg = "";
let xwind_to = ""; 
let taxi_wind = "";
let short_to = "";
let short_ldg = "";
let IFR_pattern_A = "";
let IFR_pattern_B = "";
let holding = "";
let LOC_LDA_SDF = "";
let angle_approaches = "";
let wet_compass = "";
let no_gyro_gps = "";
let celcius = "";
let precision_approach = "";
let notams = "https://notams.aim.faa.gov/notamSearch/nsapp.html#/"
let cfr = "https://www.ecfr.gov/current/title-14/chapter-I/subchapter-F/part-91/subpart-B"
let afd = "https://www.faa.gov/air_traffic/flight_info/aeronav/digital_products/dafd/";
let arrivals = "";
let emergencies = "";
let rnav = "";

let termProcedures = "https://www.faa.gov/air_traffic/flight_info/aeronav/digital_products/dtpp/search/";
let adipFaa = "https://adip.faa.gov/agis/public/#/public"






let lessons =[
    
    {id: 1100, type: 'crosswind landings', lesson_link:  xwind_ldg},
    {id: 1110, type: 'crosswind takeoffs', lesson_link:  xwind_to},
    {id: 1111, type: 'taxiing and wind correction', lesson_link: taxi_wind},
    {id: 1112, type: 'short field takeoffs', lesson_link: short_to},
    {id: 1113, type: 'short field landings', lesson_link: short_ldg},
    {id: 1114, type: 'IFR: pattern_A', lesson_link: IFR_pattern_A},
    {id: 1115, type: 'IFR: pattern_B', lesson_link: IFR_pattern_B},
    {id: 1116, type: 'IFR: Holding', lesson_link: holding},
    {id: 1117, type: 'IFR: LOC,LDA,SDF', lesson_link: LOC_LDA_SDF},
    {id: 1118, type: 'IFR: Angle Approaches', lesson_link: angle_approaches},
    {id: 1119, type: 'IFR: Wet Compass', lesson_link: wet_compass},
    {id: 1120, type: 'IFR: No Gyro or GPS', lesson_link: no_gyro_gps},
    {id: 1121, type: 'IFR: Precision Approach', lesson_link: precision_approach},
    {id: 1122, type: 'IFR: Arrivals', lesson_link: arrivals},
    {id: 1123, type: 'IFR: Emergencies', lesson_link: emergencies},
    {id: 1124, type: 'Celsius to Fahrenheit', lesson_link: celcius},
    {id: 1125, type: 'NOTAMS', lesson_link: notams},
    {id: 1126, type: 'Code of Federal Regulations', lesson_link: cfr},
    {id: 1127, type: 'Chart Supplement: A/FD', lesson_link: afd},
    {id: 1128, type: 'IFR: RNAV approaches', lesson_link: rnav},

  
    {id: 1131, type: 'Terminal Procedures', lesson_link: termProcedures},
    {id: 1132, type: 'Airport Data FAA', lesson_link: adipFaa},
]

export default lessons;